import { render, staticRenderFns } from "./RegulationsReviewSection.vue?vue&type=template&id=250db550&scoped=true&"
import script from "./RegulationsReviewSection.vue?vue&type=script&lang=js&"
export * from "./RegulationsReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsReviewSection.vue?vue&type=style&index=0&id=250db550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250db550",
  null
  
)

export default component.exports